import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cx-checkout-orchestrator',
  templateUrl: './checkout-orchestrator.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CheckoutOrchestratorComponent {
  constructor() {}
}
